import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FetchBdnFileComponent } from 'src/app/shared/components/fetch-bdn-file/fetch-bdn-file.component';
import { GenerateEmissionReportComponent } from 'src/app/shared/components/generate-emission-report/generate-emission-report.component';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getmonths, getShipNameOptions, gettypeofreport, getvesselname } from 'src/app/shared/helpers/dropdown-options';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';

import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmissionService } from 'src/app/shared/service/emission-service/emission.service';


@Component({
  selector: 'app-inside-bdn-view',
  templateUrl: './inside-bdn-view.component.html',
  styleUrls: ['./inside-bdn-view.component.scss']
})
export class InsideBdnViewComponent {
  @ViewChild(MatSort) sort!: MatSort;

  myreportForm: FormGroup;
  monthOptions: any;
  shipnameoptions: any;
  vesselnameoptions: any;
  typeofreportoptions: string[];

  paginatedData: any[] = [];
  currentPage: number = 0;
  itemsPerPage: number = 100;

  elements: any[] = [];
  // tableData: any[] = [];
  vesselNameSuggestions: any[] = [];


  selectedReport: string = '';

  isLoading = false;




  reportOptions = [
    { label: 'Average Temp Forecast', value: 'avg_temp_forecast' },
    { label: 'Tank Temp Forecast', value: 'tank_temp_forecast' },
    { label: 'Heat Plan', value: 'heat_plan' },
    { label: 'Bunker Report', value: 'bunker_forecast' }
  ];
  subusername: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private commonService: CargoheatingCommonService,
    private router: Router,
    private datePipe: DatePipe,
    private overlayService: OverlapService,
    private requestFormService: RequestFormService,
    private dialog: MatDialog,
    private emissionService: EmissionService,
    private activatedRoute: ActivatedRoute

  ) {
    this.myreportForm = this.fb.group({
      vesselname: [''],
      typeofreport: [''],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
      month: ['', Validators.required],
      vesselIMO: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    });

    this.monthOptions = getmonths();
    this.shipnameoptions = getShipNameOptions();
    this.vesselnameoptions = getvesselname();
    this.typeofreportoptions = gettypeofreport();

    this.paginateData();

  }


  ngOnInit(): void {
    this.subusername = localStorage.getItem('loginPic') ?? '';
    const imoFromRoute = this.activatedRoute.snapshot.queryParams['imo'];
    const imoFromForm = this.myreportForm.get('vesselIMO')?.value;
    const imo = imoFromRoute || imoFromForm;

    if (imo) {
      this.myreportForm.get('vesselIMO')?.setValue(imo);
      this.fetchReportTableData(imo);
    } else {
      this.toastr.info('No IMO provided');
    }
  }


  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }

  openBdnPopup(row: any) {
    localStorage.setItem('lop_imo', row.imo);

    this.dialog.open(FetchBdnFileComponent, {
      width: '550px',
      panelClass: 'beautiful-popup',
      disableClose: true,
      data: {
        imo: row.imo,
        rowData: row
      }
    });
  }




  openInsideTable(row: any) {
    this.router.navigate(['/E-Bdn-InsideView'], {
      queryParams: {
        id: row.id
      }
    });
  }
  // fetchReportTableData(): void {
  //   this.isLoading = true;

  //   this.commonService.getFinalReportTableData().subscribe(
  //     (data: any) => {
  //       const username = localStorage.getItem('username')?.toLowerCase() || '';
  //       if (username.includes('bunge')) {
  //         this.tableData = data.filter((item: any) => item?.client?.toLowerCase() === 'bunge_sa');
  //       } else {
  //         this.tableData = data;
  //       }
  //       this.isLoading = false;
  //       this.elements = [...this.tableData];
  //       this.paginateData();
  //     },
  //     () => {
  //       this.isLoading = false;
  //     }
  //   );
  // }
  fetchReportTableData(imo: number | string): void {
    this.isLoading = true;

    this.emissionService
      .getDocumentListByIMO(Number(imo), 'BDN', true)
      .subscribe({
        next: (res: any) => {
          const tableData = res?.documents || [];

          if (tableData.length > 0) {
            this.elements = tableData;
            this.currentPage = 0;
            this.paginateData();
          } else {
            this.elements = [];
            this.paginatedData = [];
            this.toastr.info('No BDN records found');
          }

          this.isLoading = false;
        },
        error: (err) => {
          console.error('BDN API error:', err);
          this.toastr.error('Failed to load BDN data');
          this.isLoading = false;
        }
      });
  }



  showDetails(row: any) {
    //this.sharedDataService.setRowData(row);
    this.router.navigate(['/E-ciitable']);
  }
  onReportSelect(selectedType: string, row: any) {
    const payload = {
      report_type: selectedType,
      vessel_imo: row.ship_imo,
      hp_number: row.hp_np,
      voyage_no: row.voyage_no,
    };

    this.commonService.printFinalReport(payload).subscribe(
      (response: any) => {
        this.overlayService.showPdf(response);
      },
      () => {
        this.toastr.info(ToasterMessages.RecordNotFount);
      }
    );
  }

  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    const isAsc = sort.direction === 'asc';

    this.paginatedData = data.sort((a, b) => {
      const valueA = a[sort.active];
      const valueB = b[sort.active];
      if (valueA == null) return isAsc ? -1 : 1;
      if (valueB == null) return isAsc ? 1 : -1;
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    });
  }

  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.elements.slice(startIndex, startIndex + this.itemsPerPage);
  }
  printBDN(row: any) {
    console.log('Print BDN:', row);
  }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  filterClick() {
    const from = this.myreportForm.get('from_date')?.value ? new Date(this.myreportForm.get('from_date')?.value) : null;
    const to = this.myreportForm.get('to_date')?.value ? new Date(this.myreportForm.get('to_date')?.value) : null;

    const vesselIMO = this.myreportForm.get('vesselIMO')?.value?.trim() || '';
    const month = this.myreportForm.get('month')?.value || '';
    const vesselName = this.myreportForm.get('vesselname')?.value?.trim() || '';
    const reportType = this.myreportForm.get('typeofreport')?.value?.trim() || '';

    // const filtered = this.tableData.filter((row) => {
    //   const rowDate = row.ingested_time ? new Date(row.ingested_time) : null;

    //   return (
    //     (!from || (rowDate && rowDate >= from)) &&
    //     (!to || (rowDate && rowDate <= to)) &&
    //     (!month || row.voyage_month === month) &&
    //     (!vesselIMO || row.ship_imo?.toLowerCase().includes(vesselIMO.toLowerCase())) &&
    //     (!vesselName || row.ship_name?.toLowerCase().includes(vesselName.toLowerCase())) &&
    //     (!reportType || row.report_type === reportType)
    //   );
    // });

    // this.paginatedData = filtered;
  }

  downloadClick() {
    const parseDate = (dateString: any) => {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${date.getFullYear()}`;
      }
      return '';
    };

    const data = this.paginatedData;

    const csvHeader = 'S.No,Ship Name,Ship IMO,Report Type,Voyage Month,Ingested Time';

    const csvData = data
      .map((row: any, index: number) => {
        const ingested = row.ingested_time ? parseDate(row.ingested_time) : '';
        return `${index + 1},${row.ship_name},${row.ship_imo},${row.report_type},${row.voyage_month},${ingested}`;
      })
      .join('\n');

    const csvContent = `${csvHeader}\n${csvData}`;

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'final_report_data.csv';
    a.click();
  }

  clearClick() {
    const imo = this.myreportForm.get('vesselIMO')?.value;
    this.myreportForm.reset();
    if (imo) {
      this.myreportForm.get('vesselIMO')?.setValue(imo);
      this.fetchReportTableData(imo);
    }
  }

  goBack() {
    this.router.navigate(['/ch-graph']);
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }


  filterShipNames(event: any) {
    const input = event.target.value.toLowerCase();
    this.vesselNameSuggestions = this.vesselnameoptions.filter((item: any) =>
      item.ship_name.toLowerCase().includes(input)
    );
  }
  refreshPageData() {
    const imo = this.myreportForm.get('vesselIMO')?.value;
    if (imo) {
      this.isLoading = true;
      this.fetchReportTableData(imo);
    }
  }

  openGenerateReportPopup(row: any) {
    this.dialog.open(GenerateEmissionReportComponent, {
      width: '560px',
      data: { ...row, reportType: 'CII' },
      disableClose: true
    });
  }

  printFinalReport(row: any) {
    const payload = {
      vessel_imo: row.ship_imo,
      voyage_no: row.voyage_no
    };

    this.commonService.printFinalReport(payload).subscribe(
      (res: any) => {
        this.overlayService.showPdf(res);
      },
      () => {
        this.toastr.error('Report Not Found');
      }
    );
  }
}

